/*
 * Created with vue 2
 * Author: Jay/jaytanweb@163.com
 * Date: 2018/4/20
 * Time: 15:09
 */
<template>
  <div id='gallery' class='gallery' :class="{ 'gallery-mb': ifMobileVisible, 'gallery-Mac': ifMacVisible, 'gallery-iPad': ifIPadVisible }" @wheel.prevent.stop>
    <div class="gallery-container">
      <div class="gallery-top">
        <p class="gallery-title">{{ bigTitle }}</p>
        <span class="gallery-close" @click="emitGalleryClose"></span>
      </div>
      <div id="gallery-1" class="carousel-container gallery-story-h" :class="{ 'carousel-container-opacity': storyVisibility, 'gallery-1-mb': ifMobileVisible }">
        <sp-carousel id="c2" :update="updateGc1" :trigger="c2HasTrigger" width="1000" :inner-text="storyText" @indexChange="setBigTitleAndBar">
          <sp-carousel-item v-for="(item, index) in story" :key="index">
            <img v-lazy="item" :alt="index">
          </sp-carousel-item>
        </sp-carousel>
      </div>
      <div id="gallery-2" class="carousel-container gallery-roles-h" :class="{ 'carousel-container-opacity': rolesVisibility }">
        <sp-carousel id="c3" :update="updateGc2" width="1000" :inner-text="rolesText" @indexChange="setBigTitleAndBar">
          <sp-carousel-item v-for="(item, index) in roles" :key="index" :id="`c3${index}`">
            <img v-lazy="item" :alt="index" class="imagesAD">
          </sp-carousel-item>
        </sp-carousel>
      </div>
    </div>
  </div>
</template>

<script>
import carousel from '../components/simple/sp-carousel'
import item from '../components/simple/sp-carousel-item'

import r1 from '../assets/images/index/roles/character01.png'
import r2 from '../assets/images/index/roles/character02.png'
import r3 from '../assets/images/index/roles/character03.png'
import r4 from '../assets/images/index/roles/character04.png'

import s1 from '../assets/images/index/story/story01.jpg'
import s2 from '../assets/images/index/story/story02.jpg'
import s3 from '../assets/images/index/story/story03.jpg'
import s4 from '../assets/images/index/story/story04.jpg'
import s5 from '../assets/images/index/story/story05.jpg'
import s6 from '../assets/images/index/story/story06.jpg'
import s7 from '../assets/images/index/story/story07.jpg'
import s8 from '../assets/images/index/story/story08.jpg'
import s9 from '../assets/images/index/story/story09.jpg'
import s10 from '../assets/images/index/story/story10.jpg'
import s11 from '../assets/images/index/story/story11.jpg'
import s12 from '../assets/images/index/story/story12.jpg'
import s13 from '../assets/images/index/story/story13.jpg'

import sm1 from '../assets/images/index-mb/story/01.png'
import sm2 from '../assets/images/index-mb/story/02.png'
import sm3 from '../assets/images/index-mb/story/03.png'
import sm4 from '../assets/images/index-mb/story/04.png'
import sm5 from '../assets/images/index-mb/story/05.png'
import sm6 from '../assets/images/index-mb/story/06.png'
import sm7 from '../assets/images/index-mb/story/07.png'
import sm8 from '../assets/images/index-mb/story/08.png'
import sm9 from '../assets/images/index-mb/story/09.png'
import sm10 from '../assets/images/index-mb/story/10.png'
import sm11 from '../assets/images/index-mb/story/11.png'
import sm12 from '../assets/images/index-mb/story/12.png'
import sm13 from '../assets/images/index-mb/story/13.png'

export default {
  name: 'gallery',
  props: {
    groupName: {
      type: String,
      require: false
    }
  },
  data () {
    return {
      // images: [],
      roles: [r1, r2, r3, r4],
      rolesText: ['인물-1', '인물-2', '인물-3', '인물-4'],
      storyMb: [sm1, sm2, sm3, sm4, sm5, sm6, sm7, sm8, sm9, sm10, sm11, sm12, sm13],
      story: [s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13],
      storyText: ['스토리-1', '스토리-2', '스토리-3', '스토리-4', '스토리-5', '스토리-6', '스토리-7', '스토리-8', '스토리-9', '스토리-10', '스토리-11', '스토리-12', '스토리-13'],
      storyVisibility: false,
      rolesVisibility: false,
      bigTitle: '',
      updateGc1: false,
      updateGc2: false,
      c2HasTrigger: true,
      ifMobileVisible: false,
      ifMacVisible: false,
      ifIPadVisible: false
    }
  },
  computed: {},
  watch: {
    groupName (newVal, oldVal) {
      console.log('new:', newVal, 'old:', oldVal)
      let which2show = newVal || oldVal
      switch (which2show) {
        case 'story':
          this.storyVisibility = true
          this.updateGc1 = true
          this.rolesVisibility = false
          this.bigTitle = this.storyText[0]
          break
        case 'roles':
          this.storyVisibility = false
          this.rolesVisibility = true
          this.updateGc2 = true
          this.bigTitle = this.rolesText[0]
          break
      }
      console.log(this.storyVisibility, this.rolesVisibility)
    }
  },
  components: {
    'sp-carousel': carousel,
    'sp-carousel-item': item
  },
  methods: {
    init () {
      let H = document.body.clientHeight
      if (!this.$lib.IsPC()) { // 手机兼容
        this.c2HasTrigger = false
        this.ifMobileVisible = true
        this.story = []
        this.story = this.storyMb
        if (this.$lib.detectBrowser.iPad) this.ifIPadVisible = true
      } else if (this.$lib.IsPC() && H < 900) { // Mac兼容
        this.ifMacVisible = true
      }
    },
    stopOutsideScroll () {
      // this.$lib.wheelScrollCheck({// 禁止gallery层的鼠标滚动事件冒泡
      //   id: 'gallery',
      //   RE: 30,
      //   prevent: true,
      //   cb (re) {
      //     console.warn('on gallery wheel:', re)
      //   }
      // })
      this.$lib.touchmoveCheck({ // 禁止gallery层的触摸事件冒泡
        id: 'gallery',
        RE: 30,
        prevent: true,
        cb (re) {
          console.warn('on gallery touch:', re)
        }
      })
      // this.$lib.wheelScrollCheck({ // 开启人物关系图长图的鼠标滚动
      //   id: 'c33',
      //   RE: 30,
      //   // stop: true, // 去除
      //   prevent: false,
      //   cb (re) {
      //     console.warn('on c33:', re)
      //   }
      // })
      let c33 = document.getElementById('c33')
      c33.addEventListener('wheel', function (e) {
        e.stopPropagation()
        // e.preventDefault()
        console.log('wheel e:', e)
      }, false)
    },
    setBigTitleAndBar (index) { // 获取sp-carousel.vue提交的index值，以此为依据更改本页bigTitle
      if (this.storyVisibility) {
        this.bigTitle = this.storyText[index]
        // 由于角色模块数量过多，所以需要每4个元素前置一次bar按钮的位置
        let count = Math.floor(index / 4)
        // console.log('前置系数：', count)
        let box = document.querySelectorAll('.box')[2]
        // console.log(box)
        box.style.marginLeft = `${-(180 * 4 + 47 * 4) * count}px`
      } else {
        this.bigTitle = this.rolesText[index]
      }
    },
    emitGalleryClose () { // 将gallery关闭请求提交到index.vue
      this.$emit('visibilityChange')
    },
    addKeyupListen () {
      let vm = this
      window.addEventListener('keyup', function (re) {
        // eslint-disable-next-line
        var e = event || window.event || arguments.callee.caller.arguments[0]
        if (e && e.keyCode === 27) { // 按 Esc
          // to do
          vm.emitGalleryClose()
        }
      }, false)
    }
  },
  mounted () {
    // gallery mounted
    this.init()
    this.addKeyupListen()
    this.stopOutsideScroll()
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
.gallery {
  //begin you code
  display: none;
  opacity: 0;
  transition: all .8s;
  z-index: 8;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.8);
  /*滚动条样式*/
  /*滚动条整体部分*/
  ::-webkit-scrollbar {
    display: none;
  }
  /*滚动条小方块*/
  ::-webkit-scrollbar-thumb {
    /*background-color: rgba(0, 0, 0, 0.6);*/
    /*height: .05rem;*/
    /*border-radius: .05rem;*/
    display: none;
  }
  /*滚动轨道两端按钮*/
  ::-webkit-scrollbar-button {
    display: none;
  }
  /*滚动轨道 内阴影*/
  ::-webkit-scrollbar-track {
    display: none;
  }
  .gallery-container {
    /*display: none;*/
    /*opacity: 0;*/
    /*transition: all .8s;*/
    position: relative;
    top: 132px;
    left: 50%;
    transform: translateX(-50%);
    width: 1000px;
    height: 690px;
    .gallery-top {
      width: 100%;
      height: 50px;
      margin-bottom: 20px;
      .gallery-title {
        font-size: 30px;
        line-height: 50px;
        color: #fff;
      }
      .gallery-close {
        position: absolute;
        top: 0;
        right: 0;
        width: 50px;
        height: 50px;
        background: url("../assets/images/index/alert/lightbox-close.png") center top no-repeat;
        background-size: contain;
        cursor: pointer;
        transition: .5s;
        &:hover {
          transform: rotate(180deg);
        }
      }
    }
    .carousel-container {
      width: 100%;
      border: 1px solid #fff;
      display: none;
      opacity: 0;
      transition: all .5s;
    }
    .carousel-container-opacity {
      display: block;
      opacity: 1;
    }
    .gallery-story-h {
      height: 552px;
    }
    .gallery-roles-h {
      height: 501px;
    }
  }
}
.gallery-Mac {
  //begin you code
  display: none;
  opacity: 0;
  transition: all .8s;
  z-index: 8;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.8);
  /*滚动条样式*/
  /*滚动条整体部分*/
  ::-webkit-scrollbar {
    display: none;
  }
  /*滚动条小方块*/
  ::-webkit-scrollbar-thumb {
    /*background-color: rgba(0, 0, 0, 0.6);*/
    /*height: .05rem;*/
    /*border-radius: .05rem;*/
    display: none;
  }
  /*滚动轨道两端按钮*/
  ::-webkit-scrollbar-button {
    display: none;
  }
  /*滚动轨道 内阴影*/
  ::-webkit-scrollbar-track {
    display: none;
  }
  .gallery-container {
    /*display: none;*/
    /*opacity: 0;*/
    /*transition: all .8s;*/
    position: relative;
    top: 32px;
    left: 50%;
    transform: translateX(-50%) scale(.7);
    width: 1000px;
    height: 690px;
    .gallery-top {
      width: 100%;
      height: 50px;
      margin-bottom: 20px;
      .gallery-title {
        font-size: 30px;
        line-height: 50px;
        color: #fff;
      }
      .gallery-close {
        position: absolute;
        top: 0;
        right: 0;
        width: 50px;
        height: 50px;
        background: url("../assets/images/index/alert/lightbox-close.png") center top no-repeat;
        background-size: contain;
        cursor: pointer;
        transition: .5s;
        &:hover {
          transform: rotate(180deg);
        }
      }
    }
    .carousel-container {
      width: 100%;
      border: 1px solid #fff;
      display: none;
      opacity: 0;
      transition: all .5s;
    }
    .carousel-container-opacity {
      display: block;
      opacity: 1;
    }
    .gallery-story-h {
      height: 552px;
    }
    .gallery-roles-h {
      height: 501px;
    }
  }
}
.gallery-mb {
  //begin you code
  display: none;
  opacity: 0;
  transition: all .8s;
  z-index: 8;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.8);
  .gallery-container {
    /*display: none;*/
    /*opacity: 0;*/
    /*transition: all .8s;*/
    position: relative;
    top: 1.32rem;
    left: 50%;
    transform: translateX(-50%);
    width: 6.45rem;
    min-height: 10.90rem;
    .gallery-top {
      width: 100%;
      height: .50rem;
      margin-bottom: .20rem;
      .gallery-title {
        font-size: .30rem;
        line-height: .50rem;
        color: #fff;
      }
      .gallery-close {
        position: absolute;
        top: 0;
        right: 0;
        width: .50rem;
        height: .50rem;
        background: url("../assets/images/index/alert/lightbox-close.png") center top no-repeat;
        background-size: contain;
        cursor: pointer;
        transition: .5s;
        &:hover {
          transform: rotate(180deg);
        }
      }
    }
    .carousel-container {
      width: 100%;
      border: none;
      display: none;
      opacity: 0;
      transition: all .5s;
      .simpleCarouselItem {
      }
    }
    .carousel-container-opacity {
      display: block;
      opacity: 1;
    }
    .gallery-story-h {
      height: 10.90rem;
    }
    .gallery-roles-h {
      display: none;
    }
  }
}
.gallery-iPad {
  //begin you code
  display: none;
  opacity: 0;
  transition: all .8s;
  z-index: 8;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,.8);
  .gallery-container {
    /*display: none;*/
    /*opacity: 0;*/
    /*transition: all .8s;*/
    position: relative;
    top: -.38rem;
    left: 50%;
    transform: translateX(-50%) scale(.8);
    width: 6.45rem;
    min-height: 10.90rem;
    .gallery-top {
      width: 100%;
      height: .50rem;
      margin-bottom: .20rem;
      .gallery-title {
        font-size: .30rem;
        line-height: .50rem;
        color: #fff;
      }
      .gallery-close {
        position: absolute;
        top: 0;
        right: 0;
        width: .50rem;
        height: .50rem;
        background: url("../assets/images/index/alert/lightbox-close.png") center top no-repeat;
        background-size: contain;
        cursor: pointer;
        transition: .5s;
        &:hover {
          transform: rotate(180deg);
        }
      }
    }
    .carousel-container {
      width: 100%;
      border: none;
      display: none;
      opacity: 0;
      transition: all .5s;
      .simpleCarouselItem {
      }
    }
    .carousel-container-opacity {
      display: block;
      opacity: 1;
    }
    .gallery-story-h {
      height: 10.90rem;
    }
    .gallery-roles-h {
      display: none;
    }
  }
}
</style>
<!--覆盖swiper组件内部样式-->
<style type="text/scss" lang="scss">
#gallery-1 {
  .button-box {
    bottom: -57px;
    width: 861px;
    height: 35px;
    overflow-y: hidden;
    overflow-x: scroll;
    .box {
      width: 2904px;
      .button-item {
        width: 180px;
        height: 35px;
        margin-right: 47px;
        border: 1px solid #fff;
        padding: 4px;
        background: rgba(0,0,0,0);
        &:nth-of-type(4) {
          margin-right: 47px;
        }
        &:last-of-type {
          margin-right: 0;
        }
        .bar-white {
          background: #d9d9d9;
          width: 100%;
        }
        .bar-white-active {
          background: #700200;
          color: #fff;
        }
      }
      .button-item-active {
        border: 1px solid #c0b497;
      }
    }
  }
  .arrow-back, .arrow-forward {
    width: 30px;
    height: 60px;
    border: none;
    border-radius: 0;
    transform: none;
    top: calc(100% + 10px);
  }
  .arrow-back {
    background: url("../assets/images/index/alert/lightbox-arrow-left.png") center top no-repeat;
    background-size: contain;
  }
  .arrow-forward {
    background: url("../assets/images/index/alert/lightbox-arrow-right.png") center top no-repeat;
    background-size: contain;
  }
}
#gallery-1.gallery-1-mb {
  .button-box {
    bottom: -57px;
    width: 861px;
    height: 35px;
    overflow-y: hidden;
    overflow-x: scroll;
    .box {
      width: 2904px;
      .button-item {
        width: 180px;
        height: 35px;
        margin-right: 47px;
        border: 1px solid #fff;
        padding: 4px;
        background: rgba(0,0,0,0);
        &:nth-of-type(4) {
          margin-right: 47px;
        }
        &:last-of-type {
          margin-right: 0;
        }
        .bar-white {
          background: #d9d9d9;
          width: 100%;
        }
        .bar-white-active {
          background: #700200;
          color: #fff;
        }
      }
      .button-item-active {
        border: 1px solid #c0b497;
      }
    }
  }
  .arrows-box {
    z-index: 2;
    border: none;
    .arrow-back, .arrow-forward {
      width: .30rem;
      height: .60rem;
      border: none;
      border-radius: 0;
      transform: none;
      top: 1.30rem;
    }
    .arrow-back {
      left: -.50rem;
    }
    .arrow-forward {
      right: -.50rem;
    }
  }

  .arrow-back {
    background: url("../assets/images/index/alert/lightbox-arrow-left.png") center top no-repeat;
    background-size: contain;
  }
  .arrow-forward {
    background: url("../assets/images/index/alert/lightbox-arrow-right.png") center top no-repeat;
    background-size: contain;
  }
}
#gallery-2 {
  .button-box {
    bottom: -108px;
    width: 861px;
    height: 35px;
    overflow-y: hidden;
    overflow-x: auto;
    .button-item {
      width: 180px;
      height: 35px;
      margin-right: 47px;
      border: 1px solid #fff;
      padding: 4px;
      background: rgba(0,0,0,0);
      &:nth-of-type(4) {
        margin-right: 0;
      }
      .bar-white {
        background: #d9d9d9;
        width: 100%;
      }
      .bar-white-active {
        background: #700200;
        color: #fff;
      }
    }
    .button-item-active {
      border: 1px solid #c0b497;
    }
  }
  .arrow-back, .arrow-forward {
    width: 30px;
    height: 60px;
    border: none;
    border-radius: 0;
    transform: none;
    top: calc(100% + 60px);
  }
  .arrow-back {
    background: url("../assets/images/index/alert/lightbox-arrow-left.png") center top no-repeat;
    background-size: contain;
  }
  .arrow-forward {
    background: url("../assets/images/index/alert/lightbox-arrow-right.png") center top no-repeat;
    background-size: contain;
  }
}
</style>



// WEBPACK FOOTER //
// src/index/gallery.vue